<template>
	<!-- OA审批 -->
	<div>
		<div v-show="QAsp">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">OA审批</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:40px"></div>
					<div style="display:inline-block;margin-left:20px">
						<span>审批类型 </span>
						<el-select v-model="condition.examine_type" style="margin-left:10px;width:180px"
							:placeholder="postPlaceholder" clearable>
							<el-option v-for="item in typeList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
					</div>

					<div style="display:inline-block;margin-left:20px">
						<span>审批状态 </span>
						<el-select v-model="condition.reviewer_state" style="margin-left:10px;width:180px"
							placeholder="请选择" clearable>
							<el-option v-for="item in ztList" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>

					<el-input v-model="condition.staff_name" placeholder="请输入查询内容"
						style="width: 180px; margin-left: 10px;"></el-input>

					<!-- 按钮 -->
					<div style="display:inline-block;margin-left:50px">
						<el-button type="goon" @click="Find">查询</el-button>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:2% 0 0 0">
					<el-table :header-cell-style="{ background: '#F0F0F0', color: '#000000' }"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="520" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55">
						</el-table-column>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{ scope_1.$index + 1 }}</template>
						</el-table-column>
						<el-table-column prop="examine_type_title" align="center" label="审批类型"></el-table-column>
						<el-table-column prop="examine_name"  label="审批名称"></el-table-column>
						<el-table-column prop="create_time" align="center" label="提出时间"></el-table-column>
						<el-table-column prop="" align="center" label="状态" width=100>
							<template slot-scope="scope">
								<img src="../../../assets/待审批.png" v-show="scope.row.reviewer_state === '0'" />
								<img src="../../../assets/已同意.png" v-show="scope.row.reviewer_state === '1'" />
								<img src="../../../assets/stateImg/状态_已驳回.png"
									v-show="scope.row.reviewer_state === '2'" />
							</template>
						</el-table-column>
						<el-table-column prop="create_time" align="center" label="通过时间"></el-table-column>
						<el-table-column align="center" label="操作" width="100">
							<template slot-scope="scope">
								<img src="../../../assets/岗位.png" @click="JieDian(scope.row.id)">
								<img src="../../../assets/详情.png" @click="xiangqing(scope.row)">
							</template>
						</el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style="margin-top: 10px; text-align: center;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>

			</div>
		</div>

		<el-dialog title="查看审批流程" :visible.sync="jiedian" width="20%" :before-close="closeJiedian">
			<div>
				<el-steps :active="active" finish-status="success" direction="vertical" class="step">
					<el-step :title="item.name" :description="item.liyou" :key="index"
						v-for="(item,index) in jiedianList">
					</el-step>
				</el-steps>
			</div>
		</el-dialog>

		<jbsq ref="jbsqs" v-show="showjbsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></jbsq>
		<qjsq ref="qjsqs" v-show="showqjsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></qjsq>
		<gwzysq ref="gwzysqs" v-show="showgwzysq" :editData="editData" :id="id" :reviewer_state="reviewer_state">
		</gwzysq>
		<lzsq ref="lzsqs" v-show="showlzsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></lzsq>
		<dgsq ref="dgsqs" v-show="showdgsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></dgsq>
		<wcsq ref="wcsqs" v-show="showwcsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></wcsq>
		<txsq ref="txsqs" v-show="showtxsq" :editData="editData" :id="id" :reviewer_state="reviewer_state" :is_reviewer_state="is_reviewer_state"></txsq>
		<bksq ref="bksqs" v-show="showbksq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></bksq>
		<ccsq ref="ccsqs" v-show="showccsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></ccsq>
		<cfsq ref="cfsqs" v-show="showcfsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></cfsq>
		<rzsq ref="rzsqs" v-show="showrzsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></rzsq>
		<tgsq ref="tgsqs" v-show="showtgsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></tgsq>
		<zzsq ref="zzsqs" v-show="showzzsq" :editData="editData" :id="id" :reviewer_state="reviewer_state"></zzsq>
		<gzmx ref="gzmxs" v-show="showgzmx" :editData="editData" :spare="spare" :id="id" :infor="infor" :examine_name="examine_name"
			:reviewer_state="reviewer_state" :is_reviewer_state="is_reviewer_state"></gzmx>
		<gzzb ref="gzzbs" v-show="showgzzb" :editData="editData" :spare="spare" :id="id" :infor="infor" :examine_name="examine_name"
			:reviewer_state="reviewer_state" :is_reviewer_state="is_reviewer_state"></gzzb>
		<gzhz ref="gzhzs" v-show="showgzhz" :editData="editData" :spare="spare" :id="id" :infor="infor" :examine_name="examine_name"
			:reviewer_state="reviewer_state" :is_reviewer_state="is_reviewer_state"></gzhz>

	</div>
</template>

<script>
	import axios from "axios";

	import jbsq from './QAsp_jbsq.vue';
	import qjsq from './QAsp_qjsq.vue';
	import gwzysq from './QAsp_gwzysq.vue';
	import lzsq from './QAsp_lzsq.vue';
	import dgsq from './QAsp_dgsq.vue';
	import wcsq from './QAsp_wcsq.vue';
	import txsq from './QAsp_txsq.vue';
	import bksq from './QAsp_bksq.vue';
	import ccsq from './QAsp_ccsq.vue';
	import cfsq from './QAsp_cfsq.vue';
	import rzsq from './QAsp_rzsq.vue';
	import tgsq from './QAsp_tgsq.vue';
	import zzsq from './QAsp_zzsq.vue';
	import gzmx from './QAsp_gzmx.vue';
	import gzzb from './QAsp_gzzb.vue';
	import gzhz from './QAsp_gzhz.vue';

	export default {
		components: {
			jbsq: jbsq,
			qjsq: qjsq,
			gwzysq: gwzysq,
			lzsq: lzsq,
			dgsq: dgsq,
			wcsq: wcsq,
			txsq: txsq,
			bksq: bksq,
			ccsq: ccsq,
			cfsq: cfsq,
			rzsq: rzsq,
			tgsq: tgsq,
			zzsq: zzsq,
			gzmx: gzmx,
			gzzb: gzzb,
			gzhz: gzhz,
		},
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				page_num: 1,
				page_size: 10,
				total: 0,
				tableData: [],
				staffList: [],
				jiedianList: [],
				jiedian: false,
				active:"",
				ruleForm: {
					id: '',
					company_name: '',
					plate_name: '',
					city: '',
					project_name: '',
					staff_name: '',
					post_name: '',
					examine_type: '',
					create_time: '',
					reviewer_state: '',
					examine_type_title: '',
				},
				// 权限
				QAsp: true,
				showjbsq: false,
				showqjsq: false,
				showgwzysq: false,
				showlzsq: false,
				showdgsq: false,
				showwcsq: false,
				showtxsq: false,
				showbksq: false,
				showccsq: false,
				showcfsq: false,
				showrzsq: false,
				showtgsq: false,
				showzzsq: false,
				showgzmx: false,
				showgzzb: false,
				showgzhz: false,
				ids: [],
				//条件
				condition: {
					organize_ids: [],
					city: '',
					create_time_start: '',
					create_time_end: '',
					create_time: '',
					examine_type: '',
					applicant_id: '',
					reviewer_state: '',
				},
				ztList: [{
					value: '0',
					label: '待审批'
				}, {
					value: '1',
					label: '已同意'
				}, {
					value: '2',
					label: '已驳回'
				}],

				//员工下拉
				staffList: [],
				//类型下拉
				typeList: [{
						value: 1,
						label: "加班审批"
					},
					{
						value: 2,
						label: "请假审批"
					},
					{
						value: 3,
						label: "岗位支援审批"
					},
					{
						value: 4,
						label: "离职审批"
					},
					{
						value: 5,
						label: "代岗审批"
					},
					{
						value: 6,
						label: "外出审批"
					},
					{
						value: 7,
						label: "调薪审批"
					},
					{
						value: 8,
						label: "补卡审批"
					},
					{
						value: 9,
						label: "出差审批"
					},
					{
						value: 10,
						label: "处罚审批"
					},
					{
						value: 11,
						label: "入职审批"
					},
					{
						value: 12,
						label: "调岗审批"
					},
					{
						value: 13,
						label: "转正审批"
					},
					{
						value: 14,
						label: "工资明细审批"
					},
					{
						value: 15,
						label: "工资占比审批"
					},
					{
						value: 16,
						label: "工资汇总审批"
					}
				],

				//详情数据
				editData: {},
				//列表id
				id: "",
				infor:"",
				spare: "",
				//列表状态
				reviewer_state: "",

				is_reviewer_state: "",
				examine_name:"",

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},
			};
		},
		methods: {
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach((item) => {
					this.ids.push(item.id);
				});
			},
			// 返回
			Return() {
				this.showjbsq = false;
				this.showqjsq = false;
				this.showgwzysq = false;
				this.showlzsq = false;
				this.showdgsq = false;
				this.showwcsq = false;
				this.showtxsq = false;
				this.showbksq = false;
				this.showccsq = false;
				this.showcfsq = false;
				this.showrzsq = false;
				this.showtgsq = false;
				this.showzzsq = false;
				this.showgzmx = false;
				this.showgzzb = false;
				this.showgzhz = false;
				this.QAsp = true;
				this.Find();
			},

			JieDian(id) {
				this.jiedian = true;
				axios.get(this.$globals.http + 'examineDetails/selectExamineDetailsList', {
					params: {
						examineId: id
					}
				}).then(res => {
						this.active = res.data.data.node;
					var List = res.data.data.examineDetailsList;
					for (var i = 0; i < List.length; i++) {
						var obj = {
							//传参
							name: List[i].staff_name,
							liyou: List[i].reject_reason || '无',
						};
						this.jiedianList.push(obj);
						
					}

				}).catch(err => {
					console.log(err)
				})
			},
			closeJiedian() {
				this.jiedian = false;
				this.jiedianList = [];
			},


			// 操作详情
			async xiangqing(data) {
				this.id = data.id;
				this.editData = data;
				this.reviewer_state = data.reviewer_state;
				this.is_reviewer_state = data.is_reviewer_state;
				this.examine_name = data.examine_name;
				this.spare = data.spare5;
				if(data.examine_type == '7'){
					this.$refs["txsqs"].editData = data
					this.$refs["txsqs"].edit()
					this.QAsp = false
					this.showtxsq = true
					return;
				}else if (data.examine_type == '14') {
					axios.get(this.$globals.http + 'examineDetails/getExamineUserThree', {
						params: {
							examineId: data.id
						}
					}).then(res => {
						this.infor = res.data.data;
					}).catch(err => {
						console.log(err)
					});
					this.$refs["gzmxs"].editData = data
					this.$refs["gzmxs"].edit()
					this.QAsp = false
					this.showgzmx = true
					return;
				} else if (data.examine_type == '15') {
					axios.get(this.$globals.http + 'examineDetails/getExamineUserTwo', {
						params: {
							examineId: data.id
						}
					}).then(res => {
						this.infor = res.data.data;
					}).catch(err => {
						console.log(err)
					});
					this.$refs["gzzbs"].editData = data
					this.$refs["gzzbs"].edit()
					this.QAsp = false
					this.showgzzb = true
					return;
				} else if (data.examine_type == '16') {
					axios.get(this.$globals.http + 'examineDetails/getExamineUserOne', {
						params: {
							examineId: data.id
						}
					}).then(res => {
						this.infor = res.data.data;
					}).catch(err => {
						console.log(err)
					});
					this.$refs["gzhzs"].editData = data
					this.$refs["gzhzs"].edit()
					this.QAsp = false
					this.showgzhz = true
					return;
				}
			},
			//查询
			async Find() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'examine/find';
				var record = {
					page_num: this.page_num,
					page_size: this.page_size,
					organize_ids: organize_ids,
					city: this.condition.city,
					create_time: this.condition.create_time,
					examine_type: this.condition.examine_type,
					applicant_id: this.$globals.user.staff_id,
					reviewer_state: this.condition.reviewer_state,
					user_id: this.$globals.user.id,
					role_id: this.$globals.user.role_id,

				};
				var user = this.$globals.user;
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list;

						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},
			//分页
			handleCurrentChange(val) {
				this.page_num = val;
				this.Find();
			},
			//清除数据
			trash() {
				this.ruleForm.id = '';
				this.ruleForm.company_name = '';
				this.ruleForm.plate_name = '';
				this.ruleForm.city = '';
				this.ruleForm.project_name = '';
				this.ruleForm.staff_name = '';
				this.ruleForm.post_name = '';
				this.ruleForm.examine_type = '';
				this.ruleForm.create_time = '';
				this.ruleForm.reviewer_state = '';
				this.ruleForm.is_reviewer_state = '';
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.Find();
			this.organizeFind();
			//员工
			var staffList = await this.$globals.AxiosPost("staff/selectFind", {});
			this.staffList = staffList.data;
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}
</style>



// WEBPACK FOOTER //
// QAsp.vue?7a3cc5dc